<template>
  <div>
    <transition name="dialogfade">
      <k-dialog v-if="showDialog"
        class="edit-condition-dialog sales-notes-dialog"
        :title="'Sales Notes'"
        @close="closeDialog">
        <sales-notes-component :loan-id="loanId"></sales-notes-component>
      </k-dialog>
    </transition>
  </div>
</template>

<script>
import { Dialog, DialogActionsBar } from '@progress/kendo-vue-dialogs';
import salesNotesComponent from './salesNotesComponent.vue';

export default {
  props: ['loanId', 'showDialog'],
  emits: ['dialogclosed'],
  data() {
    return {
    }
  },
  methods: {
    closeDialog() {
      this.$emit('dialogclosed');
    }
  },
  components: {
    'k-dialog': Dialog,
    'k-dialog-actions': DialogActionsBar,
    'sales-notes-component': salesNotesComponent
  }
}
</script>

<style>
@import '/src/assets/css/salesNotesDialog.css';
</style>
